"use client";
import { useContext, useEffect, useState } from "react";
import { CartContext } from "@/context/CartContext";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { Button } from "@/components/ui/button";
import { ShoppingBag } from "lucide-react";

const EmptyCart = () => {
  const { push } = useRouter();
  const { cart } = useContext(CartContext);

  const [cartProducts, setCartProducts] = useState([]);

  useEffect(() => {
    setCartProducts(cart);
  }, [cart]);

  return (
    <>
      {cartProducts?.length === 0 && (
        <Card className="flex items-center justify-center flex-col gap-2 border border-brand-light shadow-brand rounded-2xl py-6">
          <CardHeader className="flex flex-col items-center gap-3">
            <div className="w-16 h-16 rounded-full bg-brand-light flex items-center justify-center">
              <ShoppingBag className="w-7 h-7 text-brand-deep" />
            </div>
            <CardTitle className="text-brand-navy text-xl text-center">
              Your Ichchapuron Cart is empty.
            </CardTitle>
          </CardHeader>
          <CardContent className="flex flex-col gap-5 items-center">
            <div className="text-center text-sm text-muted-foreground max-w-xl leading-relaxed">
              Your Shopping Cart lives to serve. Give it purpose — fill it with
              books, stationaries and more or visit your{" "}
              <span
                className="text-brand-sky font-semibold cursor-pointer hover:text-brand-deep hover:underline transition-colors"
                onClick={() => push("/wishlist")}
              >
                Wishlists.
              </span>
            </div>
            <Link href="/">
              <Button className="gradient-primary hover:opacity-95 text-white font-semibold rounded-xl px-6 h-11 shadow-brand hover:shadow-brand-lg transition-all">
                Continue Shopping
              </Button>
            </Link>
          </CardContent>
        </Card>
      )}
    </>
  );
};

export default EmptyCart;